import {Component, OnInit, Injector, Input} from '@angular/core';
import {AppComponentBase} from '../../services/AppComponentBase';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import {autoTable as AutoTable} from 'jspdf-autotable';
import {ICurrencyFormatter, Currencyformatters} from '../../interfaces/ICurrencyFormatters';
import {SimpleNotificationComponent} from '../simple-notification/simple-notification.component';
import * as moment from "moment";
import {Providers} from '../../enums/providers';
import {AccountPips} from '../../api/DixApiClient';
import {AccountProvider} from '../../model/workspace.data';


@Component({
  selector: 'app-printer',
  template: require('./printer.component.html'),
  styles: [require('./printer.component.scss')]
})
export class PrinterComponent extends AppComponentBase implements OnInit {

  constructor(injector: Injector) {
    super(injector);
  }

  @Input()
  public type: string = "";


  ngOnInit() {
  }

  public get activeTradeTab() {
    return this.workspace.activeTradeDeskTab
  }

  public get controlType() {
    return this.type
  }


  public get head() {
    return [{
      EntryTime: "Entry Time",
      CloseTime: "Close Time",
      Ticket: "Ticket",
      Type: "Type",
      Qty: "Qty",
      Symbol: "Symbol",
      EntryPrice: "Entry Price",
      Stop: "Stop",
      Limit: "Limit",
      ClosePrice: "Close Price",
      Pips: "Pips",
      PnLUSD: "PnLUSD"
    }];
  }


  public get body() {
    return this.workspace.visibleHistoryData
    //return [{id: 'ID', name: 'Name', email: 'Email', city: 'City', expenses: 'Sum'}];
  }

  public get bodyChallenge() {
    return this.workspace.visibleHistoryChallengeData
    //return [{id: 'ID', name: 'Name', email: 'Email', city: 'City', expenses: 'Sum'}];
  }




  public printData() {


    if(this.type == "") {
      if(this.workspace.currentProvider == Providers.DEMO || this.workspace.debugVisibility == false)
      //  if(this.workspace.currentProvider)
      {
        if(this.workspace.pdfReportHistoryDateStr != "All") {
          if(this.workspace.pdfReportHistoryDateRange.from && this.workspace.pdfReportHistoryDateRange.to) {

            this.workspace.GetPnLInTimeRange(this.workspace.currentAccountInformation.id, this.workspace.pdfReportHistoryDateRange.from, this.workspace.pdfReportHistoryDateRange.to).then(response => {
              if(response !== null) {
                console.log("ACCOUNTPIPS");
                console.log("ACCOUNTPIPS");

                console.log(response);

                let userData = {
                  acctId: this.workspace.currentAccountInformation.id,
                  acctName: this.workspace.currentAccountInformation.name,
                  initBalance: response.accountBalance![0].initialBalance,
                  endBallance: response.accountBalance![0].endBalance,
                  pips: this.workspace.historyPips,// response.sumOfPips,
                  pl: this.workspace.historyPNL//response.accountBalance![0].pnLInTimeRange,
                }

                this.printDataHistory(userData);
              }
            });

          }
        }
        else {
          this.printDataHistory()
        }
      }

      if(this.workspace.currentProvider == Providers.NONE) {
        let from = "";
        let to = "";
        if(this.workspace.pdfReportHistoryDateStr == "All") {
          from = "2000-01-01 17:12:11";
          to = moment().utc().format("YYYY-MM-DD HH:mm:ss");
          //  let to =  this.workspace.pdfReportHistoryDateRange.to.format("yyyy-MM-dd hh:mm:ss")
        }
        else {
          if(this.workspace.pdfReportHistoryDateRange.from) {
            from = this.workspace.pdfReportHistoryDateRange.from.format("YYYY-MM-DD HH:mm:ss")
          }

          if(this.workspace.pdfReportHistoryDateRange.to) {
            to = this.workspace.pdfReportHistoryDateRange.to.format("YYYY-MM-DD HH:mm:ss")
          }

        }

        this.dataService.getProviderTransactions(from, to).then(data => {
          //  debugger;
          console.log(data);
        }).catch(error => {
          //debugger;
          console.log(error)
          let config = Object.assign(this.toastr.toastrConfig, {});
          config.timeOut = 6000;
          config.progressBar = true;
          config.closeButton = true;
          config.toastComponent = SimpleNotificationComponent;

          let params: {} = {
            error: true,
            text: error
          };

          this.toastr.show(JSON.stringify(params), '', config);
        }
        )
      }

      if(this.workspace.currentProvider == Providers.OANDA && this.workspace.debugVisibility == true) {

        let from: moment.Moment = moment();
        let to: moment.Moment = moment().subtract(10, "years");

        if(this.workspace.pdfReportHistoryDateStr != "All") {

          if(this.workspace.pdfReportHistoryDateRange.from && this.workspace.pdfReportHistoryDateRange.to) {

            from = this.workspace.pdfReportHistoryDateRange.from
            to = this.workspace.pdfReportHistoryDateRange.to

          }
        }

        let selectedUser = <AccountProvider> this.workspace.accounts.find(v => {
          return v.id == this.workspace.currentAccountInformation.id;
        })


        this.dataService.getProviderTransactions(from.utc().format("YYYY-MM-DD HH:mm:ss"), to.utc().format("YYYY-MM-DD HH:mm:ss")).then(data => {
          //  debugger;
          console.log(data);
        }).catch(error => {
          //debugger;
          console.log(error)
          let config = Object.assign(this.toastr.toastrConfig, {});
          config.timeOut = 6000;
          config.progressBar = true;
          config.closeButton = true;
          config.toastComponent = SimpleNotificationComponent;

          let params: {} = {
            error: true,
            text: error
          };

          this.toastr.show(JSON.stringify(params), '', config);
        })

        // this.workspace.GetPnLInTimeRange(selectedUser.accountProviderId, from, to).then(response => {
        //   if(response !== null) {
        //     console.log("ACCOUNTPIPS");
        //     console.log("ACCOUNTPIPS");

        //     console.log(response);

        //     let userData = {
        //       acctId: this.workspace.currentAccountInformation.id,
        //       acctName: this.workspace.currentAccountInformation.name,
        //       initBalance: response.accountBalance![0].initialBalance,
        //       endBallance: response.accountBalance![0].endBalance,
        //       pips: response.sumOfPips,
        //       pl: response.accountBalance![0].pnLInTimeRange,
        //     }

        //     this.printDataHistoryOANDA(userData);
        //   }
        // });


      }
    }

    if(this.type == "challenge") {
      if(this.workspace.pdfReportHistoryDateStrChallenge != "All") {
        if(this.workspace.pdfReportHistoryDateRange.from && this.workspace.pdfReportHistoryDateRange.to) {

          this.workspace.GetPnLInTimeRange(this.workspace.selectedChallengeHistoryAccInfo.id, this.workspace.pdfReportHistoryDateRange.from, this.workspace.pdfReportHistoryDateRange.to).then(response => {
            if(response !== null) {
              console.log("ACCOUNTPIPS");
              console.log(response);

              let userData = {
                acctId: this.workspace.selectedChallengeHistoryAccInfo.id,
                acctName: this.workspace.selectedChallengeHistoryAccInfo.name,
                initBalance: response.accountBalance![0].initialBalance,
                endBallance: response.accountBalance![0].endBalance,
                pips: response.sumOfPips,
                pl: response.accountBalance![0].pnLInTimeRange,
              }

              this.printDataHistoryChallenge(userData);
            }
          });

        }
      }
      else {
        this.printDataHistoryChallenge()
      }

    }


    //  this.workspace.pdfReportHistoryDateRange = {};
  }

  public formatters: ICurrencyFormatter = Currencyformatters
  public currency = "USD";


  public printDataHistory(userdData?: any) {



    // if(this.workspace.currentAccountMoneyLine!==undefined)
    //   {

    let userData = {
      acctId: this.workspace.currentAccountInformation.id,
      acctName: this.workspace.currentAccountInformation.name,
      initBalance: this.workspace.currentAccountMoneyLine.AccountValue - this.workspace.currentAccountMoneyLine.SumOfPLUSDHistory,
      endBallance: this.workspace.currentAccountMoneyLine.Balance,
      pips: this.workspace.currentAccountMoneyLine.SumOfPipsHistory,
      pl: this.workspace.currentAccountMoneyLine.SumOfPLUSDHistory,
    }

    if(userdData != undefined) {
      userData = userdData;
    }


    //   }

    const doc = new jsPDF("landscape");
    var pageSize = doc.internal.pageSize;
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();

    doc.setFontSize(18);
    doc.text('PremiereTrade - History', 14, 22);

    doc.setFontSize(14);
    let Acct: string = "Acct# " + userData.acctId;
    doc.text(Acct, pageWidth / 2, 22);

    let Name: string = "Name: " + userData.acctName
    doc.text(Name, (pageWidth / 2) + 50, 22);

    doc.setFontSize(11);
    doc.setTextColor(100);



    var text = doc.splitTextToSize("Date Range: " + this.workspace.pdfReportHistoryDateStr, pageWidth - 35, {});
    doc.text(text, 14, 30);



    // doc.text(text, 14, 300);

    var totalPagesExp = "{total_pages_count_string}";

    ((doc as any).autoTable as AutoTable)({
      head: <any> this.head,
      body: this.body,
      theme: 'grid',
      startY: 37,
      margin: {top: 30},
      headStyles: {
        fillColor: [0, 128, 0],
        fontSize: 10
      },
      columnStyles: {
        Pips: {halign: "right"},
        Qty: {halign: "right"},
        Stop: {halign: "right"},
        Limit: {halign: "right"},
        EntryPrice: {halign: "right"},
        ClosePrice: {halign: "right"},
        PnLUSD: {halign: "right"},
      },
      bodyStyles: {
        fillColor: [255, 255, 255],
        textColor: 0,
        fontSize: 10
      },
      didParseCell: data => {
        if(data.row.section === 'body' && data.column.dataKey === "Qty") {
          data.cell.text = [this.kReplacer(data.cell.raw)];
        }
      },
      willDrawCell: data => {

        if(data.row.section === 'body' && data.column.dataKey === "Pips") {
          if(data.cell.raw < 0) {
            doc.setTextColor(231, 76, 60); // Red

          }

          if(data.cell.raw > 0) {
            doc.setTextColor(0, 128, 0);
          }
        };

        if(data.row.section === 'body' && data.column.dataKey === "PnLUSD") {

          let v1 = Number(data.cell.raw.replace("($)", "").replace("$", ""));

          if(v1 < 0) {
            doc.setTextColor(231, 76, 60); // Red

          }

          if(v1 > 0) {
            doc.setTextColor(0, 128, 0);
          }


        }




      },
      // didDrawPage: function (data) {
      //   // Footer
      //   var str = "Page " + doc.internal.getNumberOfPages()
      //   if (typeof doc.putTotalPages === 'function') {
      //       str = str + " of " + totalPagesExp;
      //   }

      //   if (typeof doc.putTotalPages === 'function') {
      //     doc.putTotalPages(totalPagesExp);
      // }

      //  }
    });

    let afterTable: number = (doc as any).autoTable.previous.finalY + 10;

    doc.setTextColor(0, 0, 0);

    doc.setFontSize(14);
    let AcctSummaryStr: string = "Acct Summary:"
    doc.text(AcctSummaryStr, 40, afterTable);

    let initialBallance: string = "Initial Balance: " + this.formatters[this.currency].format(userData.initBalance);
    doc.text(initialBallance, -30 + pageWidth / 2, afterTable);

    let endBallance: string = "End Balance: " + this.formatters[this.currency].format(userData.endBallance);
    doc.text(endBallance, 2.6 - 30 + pageWidth / 2, afterTable + 10);




    //if (data.cell.raw > 0) {
    doc.setTextColor(0, 128, 0);
    doc.setTextColor(231, 76, 60);
    //}






    let TotalPips: string = "Total Pips: " + userData.pips

    if(userData.pips > 0)
      doc.setTextColor(0, 128, 0);

    if(userData.pips < 0)
      doc.setTextColor(231, 76, 60);


    doc.text(TotalPips, 60 + pageWidth / 2, afterTable);





    let PL: string = "P/L: " + this.formatters[this.currency].format(userData.pl);

    if(userData.pl > 0)
      doc.setTextColor(0, 128, 0);

    if(userData.pl < 0)
      doc.setTextColor(231, 76, 60);


    doc.text(PL, 75 + pageWidth / 2, afterTable + 10);

    //doc.text(20, finalY, "Hello!")





    let fileName = "PremiereTrade-history-" + this.workspace.pdfReportHistoryDateStr.replace(/\s+/g, ''); + ".pdf";
    doc.save(fileName);
    window.open(doc.output('bloburl'), '_blank');


  }




  public kReplacer(v: string) {
    if(v.substr(-3, 3) == "000") {
      let length = v.length;
      return v.substring(0, length - 3) + "k";
    }

    return v;

  }





  public printDataHistoryChallenge(userdData?: any) {

    let userData = {
      acctId: this.workspace.selectedChallengeHistoryAccInfo.id,
      acctName: this.workspace.selectedChallengeHistoryAccInfo.name,
      initBalance: this.workspace.historyChallengeAccountMoneyLine.AccountValue - this.workspace.historyChallengeAccountMoneyLine.PnL,
      endBallance: this.workspace.historyChallengeAccountMoneyLine.Balance,
      pips: this.workspace.historyChallengeAccountMoneyLine.SumOfPipsHistory,
      pl: this.workspace.historyChallengeAccountMoneyLine.SumOfPLUSDHistory,
    }

    if(userdData != undefined) {
      userData = userdData;
    }


    const doc = new jsPDF("landscape");

    var pageSize = doc.internal.pageSize;
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();

    doc.setFontSize(18);
    doc.text('PremiereTrade - challenge', 14, 22);

    doc.setFontSize(14);
    let Acct: string = "Acct# " + userData.acctId;
    doc.text(Acct, pageWidth / 2, 22);

    let Name: string = "Name: " + userData.acctName
    doc.text(Name, (pageWidth / 2) + 50, 22);



    doc.setFontSize(11);
    doc.setTextColor(100);

    var text = doc.splitTextToSize("Date Range: " + this.workspace.pdfReportHistoryDateStrChallenge, pageWidth - 35, {});
    doc.text(text, 14, 30);

    //  doc.text(text, 14, 300);

    var totalPagesExp = "{total_pages_count_string}";

    ((doc as any).autoTable as AutoTable)({
      head: <any> this.head,
      body: this.bodyChallenge,
      theme: 'grid',
      startY: 37,
      margin: {top: 30},
      headStyles: {
        fillColor: [0, 128, 0],
        fontSize: 10
      },
      columnStyles: {
        Pips: {halign: "right"},
        Qty: {halign: "right"},
        Stop: {halign: "right"},
        Limit: {halign: "right"},
        EntryPrice: {halign: "right"},
        ClosePrice: {halign: "right"},
        PnLUSD: {halign: "right"},
      },
      bodyStyles: {
        fillColor: [255, 255, 255],
        textColor: 0,
        fontSize: 10
      },
      didParseCell: data => {
        if(data.row.section === 'body' && data.column.dataKey === "Qty") {
          data.cell.text = [this.kReplacer(data.cell.raw)];
        }
      },
      willDrawCell: data => {

        if(data.row.section === 'body' && data.column.dataKey === "Pips") {
          if(data.cell.raw < 0) {
            doc.setTextColor(231, 76, 60); // Red

          }

          if(data.cell.raw > 0) {
            doc.setTextColor(0, 128, 0);
          }
        };

        if(data.row.section === 'body' && data.column.dataKey === "PnLUSD") {

          let v1 = Number(data.cell.raw.replace("($)", "").replace("$", ""));

          if(v1 < 0) {
            doc.setTextColor(231, 76, 60); // Red

          }

          if(v1 > 0) {
            doc.setTextColor(0, 128, 0);
          }


        }




      },
      // didDrawPage: function (data) {
      //   // Footer
      //   var str = "Page " + doc.internal.getNumberOfPages()
      //   if (typeof doc.putTotalPages === 'function') {
      //       str = str + " of " + totalPagesExp;
      //   }

      //   if (typeof doc.putTotalPages === 'function') {
      //     doc.putTotalPages(totalPagesExp);
      // }

      //  }
    });

    let afterTable: number = (doc as any).autoTable.previous.finalY + 10;

    doc.setTextColor(0, 0, 0);

    doc.setFontSize(14);
    let AcctSummaryStr: string = "Acct Summary:"
    doc.text(AcctSummaryStr, 40, afterTable);

    let initialBallance: string = "Initial Balance: " + this.formatters[this.currency].format(userData.initBalance);
    doc.text(initialBallance, -30 + pageWidth / 2, afterTable);

    let endBallance: string = "End Balance: " + this.formatters[this.currency].format(userData.endBallance);
    doc.text(endBallance, 2.6 - 30 + pageWidth / 2, afterTable + 10);




    //if (data.cell.raw > 0) {
    doc.setTextColor(0, 128, 0);
    doc.setTextColor(231, 76, 60);
    //}






    let TotalPips: string = "Total Pips: " + userData.pips

    if(userData.pips > 0)
      doc.setTextColor(0, 128, 0);

    if(userData.pips < 0)
      doc.setTextColor(231, 76, 60);


    doc.text(TotalPips, 60 + pageWidth / 2, afterTable);





    let PL: string = "P/L: " + this.formatters[this.currency].format(userData.pl);

    if(userData.pl > 0)
      doc.setTextColor(0, 128, 0);

    if(userData.pl < 0)
      doc.setTextColor(231, 76, 60);


    doc.text(PL, 75 + pageWidth / 2, afterTable + 10);






    let fileName = "PremiereTrade-history-" + this.workspace.pdfReportHistoryDateStr.replace(/\s+/g, ''); + ".pdf";
    doc.save(fileName);
    window.open(doc.output('bloburl'), '_blank');


  }






  public printDataHistoryOANDA(userdData?: any) {



    // if(this.workspace.currentAccountMoneyLine!==undefined)
    //   {

    let userData = {
      acctId: this.workspace.currentAccountInformation.id,
      acctName: this.workspace.currentAccountInformation.name,
      initBalance: this.workspace.currentAccountMoneyLine.AccountValue - this.workspace.currentAccountMoneyLine.SumOfPLUSDHistory,
      endBallance: this.workspace.currentAccountMoneyLine.Balance,
      pips: this.workspace.currentAccountMoneyLine.SumOfPipsHistory,
      pl: this.workspace.currentAccountMoneyLine.SumOfPLUSDHistory,
    }

    if(userdData != undefined) {
      userData = userdData;
    }


    //   }

    const doc = new jsPDF("landscape");
    var pageSize = doc.internal.pageSize;
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();

    doc.setFontSize(18);
    doc.text('PremiereTrade - History', 14, 22);

    doc.setFontSize(14);
    let Acct: string = "Acct# " + userData.acctId;
    doc.text(Acct, pageWidth / 2, 22);

    let Name: string = "Name: " + userData.acctName
    doc.text(Name, (pageWidth / 2) + 50, 22);

    doc.setFontSize(11);
    doc.setTextColor(100);



    var text = doc.splitTextToSize("Date Range: " + this.workspace.pdfReportHistoryDateStr, pageWidth - 35, {});
    doc.text(text, 14, 30);



    // doc.text(text, 14, 300);

    var totalPagesExp = "{total_pages_count_string}";

    ((doc as any).autoTable as AutoTable)({
      head: <any> this.head,
      body: this.body,
      theme: 'grid',
      startY: 37,
      margin: {top: 30},
      headStyles: {
        fillColor: [0, 128, 0],
        fontSize: 10
      },
      columnStyles: {
        Pips: {halign: "right"},
        Qty: {halign: "right"},
        Stop: {halign: "right"},
        Limit: {halign: "right"},
        EntryPrice: {halign: "right"},
        ClosePrice: {halign: "right"},
        PnLUSD: {halign: "right"},
      },
      bodyStyles: {
        fillColor: [255, 255, 255],
        textColor: 0,
        fontSize: 10
      },
      didParseCell: data => {
        if(data.row.section === 'body' && data.column.dataKey === "Qty") {
          data.cell.text = [this.kReplacer(data.cell.raw)];
        }
      },
      willDrawCell: data => {

        if(data.row.section === 'body' && data.column.dataKey === "Pips") {
          if(data.cell.raw < 0) {
            doc.setTextColor(231, 76, 60); // Red

          }

          if(data.cell.raw > 0) {
            doc.setTextColor(0, 128, 0);
          }
        };

        if(data.row.section === 'body' && data.column.dataKey === "PnLUSD") {

          let v1 = Number(data.cell.raw.replace("($)", "").replace("$", ""));

          if(v1 < 0) {
            doc.setTextColor(231, 76, 60); // Red

          }

          if(v1 > 0) {
            doc.setTextColor(0, 128, 0);
          }


        }




      },
      // didDrawPage: function (data) {
      //   // Footer
      //   var str = "Page " + doc.internal.getNumberOfPages()
      //   if (typeof doc.putTotalPages === 'function') {
      //       str = str + " of " + totalPagesExp;
      //   }

      //   if (typeof doc.putTotalPages === 'function') {
      //     doc.putTotalPages(totalPagesExp);
      // }

      //  }
    });

    let afterTable: number = (doc as any).autoTable.previous.finalY + 10;

    doc.setTextColor(0, 0, 0);

    doc.setFontSize(14);
    let AcctSummaryStr: string = "Acct Summary:"
    doc.text(AcctSummaryStr, 40, afterTable);

    let initialBallance: string = "Initial Balance: " + this.formatters[this.currency].format(userData.initBalance);
    doc.text(initialBallance, -30 + pageWidth / 2, afterTable);

    let endBallance: string = "End Balance: " + this.formatters[this.currency].format(userData.endBallance);
    doc.text(endBallance, 2.6 - 30 + pageWidth / 2, afterTable + 10);




    //if (data.cell.raw > 0) {
    doc.setTextColor(0, 128, 0);
    doc.setTextColor(231, 76, 60);
    //}






    let TotalPips: string = "Total Pips: " + userData.pips

    if(userData.pips > 0)
      doc.setTextColor(0, 128, 0);

    if(userData.pips < 0)
      doc.setTextColor(231, 76, 60);


    doc.text(TotalPips, 60 + pageWidth / 2, afterTable);





    let PL: string = "P/L: " + this.formatters[this.currency].format(userData.pl);

    if(userData.pl > 0)
      doc.setTextColor(0, 128, 0);

    if(userData.pl < 0)
      doc.setTextColor(231, 76, 60);


    doc.text(PL, 75 + pageWidth / 2, afterTable + 10);

    //doc.text(20, finalY, "Hello!")





    let fileName = "PremiereTrade-history-" + this.workspace.pdfReportHistoryDateStr.replace(/\s+/g, ''); + ".pdf";
    doc.save(fileName);
    window.open(doc.output('bloburl'), '_blank');


  }

















}
